<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="FATURAMENTO" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="6" :totalPDF="total - 1" :titleReport="titleReport" :totalHide="true">

            </header-table>
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-10 md-xsmall-size-100">
                        <md-field>
                            <label for="pages">Listar</label>
                            <md-select v-model="pagination.perPage" name="pages">
                                <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                    {{ item }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-field>
                            <label for="pages">Dia de Fechamento</label>
                            <md-select v-model="buscar.fechamento" name="pages">
                                <md-option v-for="item in fechamento" :key="item.id" :label="item.nome" :value="item.id">
                                    {{ item.nome }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-field>
                            <label for="pages">Periódo</label>
                            <md-select v-model="buscar.periodo" name="pages">
                                <md-option v-for="item in periodo" :key="item" :label="item" :value="item">
                                    {{ item }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-35 md-xsmall-size-100">
                        <md-field>
                            <label>Pesquisar</label>
                            <md-input type="search" class="mb-3" clearable placeholder="Fornecedor" v-model="buscar.busca">
                            </md-input>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-15 md-xsmall-size-100">
                        <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                            <md-icon>search</md-icon> BUSCAR
                        </md-button>
                    </div>
                </div>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 35%">{{ item.empresa }}</md-table-cell>
                        <md-table-cell v-if="item.id" class="uppercase" md-label="GRUPO" style="width: 35%">{{ item.grupo }}</md-table-cell>
                        <md-table-cell v-if="!item.id" class="uppercase" md-label="GRUPO" style="width: 35%"><strong>{{ item.grupo }}</strong></md-table-cell>
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>
                        <md-table-cell v-if="item.id" md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permissoes.faturamentoEmpresaCreate" @click="faturar(item.id, item.dia_fechamento)">
                                        FATURAR<md-icon class="text-info">monetization_on</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.faturamentoView" @click="visualizar(item.id, item.dia_fechamento)">
                                        VISUALIZAR<md-icon class="text-info">visibility</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="AÇÕES" style="width: 5%"></md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to - 1" :total="total - 1">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import Pagamento from '@/config/mixins/print/pagamento'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import getDateFormat from '@/config/mixins/getDateFormat';
import Swal from "sweetalert2";

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            fechamento: [],
            periodo: [],
            detalhes: {},
            totalGeral: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'pagamentos/',
            rotaExcluir: 'pagamentos/excluir/',
            titleReport: "Relatório de fechamento",
            columnsPDF: [80, 70, 30],
            headRowsPDF: ['EMPRESA', 'GRUPO', 'VALOR'],
            bodyRowsPDF: ['empresa', 'grupo', 'valor'],
            fildsTXT: ['empresa', 'grupo', 'valor_txt'],
            columnsExcel: [

                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "GRUPO",
                    field: "grupo",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "VALOR",
                    field: "valor_bd"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                fechamento: null,
                periodo: null,
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, Pagamento, getDateFormat],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'financeiro/faturamento-empresas', this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.fechamento = response.data.fechamento
                        this.periodo = response.data.mesAno
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.totalGeral = response.data.total
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.empresa, item.grupo, item.valor]).includes(this.toLower(term)))
            }
            return items
        },

        visualizar(id, dia) {
            let periodo = this.buscar.periodo ? this.buscar.periodo : this.periodo[0];          
            this.$router.push({
                name: 'faturamentoView',
                params: {id: id},
                query: { periodo: periodo, dia: dia }
            })
        },

        faturar(id, dia) {
            this.dados.id = id,
            this.dados.dia = dia,
            this.dados.periodo = this.buscar.periodo ? this.buscar.periodo : this.periodo[0];
            this.$http.post(this.$urlAPI + 'financeiro/faturamento-faturar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.success(response.data.message)
                        this.read()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    },
};
</script>

<style>
.md-layout-item {
    margin-top: 5px;
}
</style>
